import React from "react"

const Prose = ({ children }) => (
  <article className="prose prose-neutral prose-xl 
    prose-headings:font-bold prose-headings:text-bggreen max-w-none leading-tight prose-a:text-borange-600 hover:prose-a:text-borange-500">
    {children}
  </article>
)

export default Prose
